import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";

document.body.setAttribute("spellcheck", false);
ReactDOM.render(<App />, document.getElementById("root"));
